"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
var _state = require("./state");
var _lodashReplacement = _interopRequireDefault(require("./lodashReplacement"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var cloneDeep = _lodashReplacement.default.cloneDeep;
var _default = function _default(postal) {
  var queue = [];
  postal.addWireTap(function (data, envelope) {
    if (_state.state._config.queueingEnabled) {
      queue.push(cloneDeep(envelope));
    }
  });
  postal.iterateOverQueue = function () {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    queue.forEach(callback);
  };
};
exports.default = _default;